/**
 * Spinner — Loading spinner with configurable size.
 */

import { clsx } from 'clsx';

export type SpinnerSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

export interface SpinnerProps {
  size?: SpinnerSize;
  className?: string;
  label?: string;
}

const sizeMap: Record<SpinnerSize, string> = {
  xs: 'w-3 h-3 border-2',
  sm: 'w-4 h-4 border-2',
  md: 'w-6 h-6 border-2',
  lg: 'w-8 h-8 border-3',
  xl: 'w-12 h-12 border-4',
};

export function Spinner({ size = 'md', className, label = 'Loading' }: SpinnerProps) {
  return (
    <div
      className={clsx(
        'inline-block animate-spin rounded-full border-gray-200 border-t-primary-600',
        sizeMap[size],
        className,
      )}
      role="status"
      aria-label={label}
    >
      <span className="sr-only">{label}…</span>
    </div>
  );
}

export default Spinner;